import * as React from "react";

import { Loader2Icon } from "lucide-react";

import { cn } from "../../utils";

const Spinner = ({ className, ...props }: React.ComponentProps<"svg">) => {
  return (
    <Loader2Icon
      role="status"
      aria-label="Loading"
      className={cn("af-size-4 af-animate-spin", className)}
      {...props}
    />
  );
};
Spinner.displayName = "Spinner";

export { Spinner };
